import { apiRequest } from "@/data/api/client";

export interface PushSubscriptionKeys {
  p256dh: string;
  auth: string;
}

export interface StoredPushSubscription {
  endpoint: string;
  keys: PushSubscriptionKeys;
}

export const partnerPushRepo = {
  /** The VAPID public key the browser subscribes with. It belongs to the
   *  environment, not to the build, so it is read rather than bundled. */
  async publicKey(): Promise<string> {
    const { publicKey } = await apiRequest<{ publicKey: string }>("/v1/partner/push/key");
    return publicKey;
  },

  /** Idempotent: the same endpoint arriving again refreshes its keys, which is
   *  how a browser that renewed its subscription is healed on the next visit. */
  async subscribe(subscription: StoredPushSubscription): Promise<void> {
    await apiRequest("/v1/partner/push/subscriptions", { method: "POST", body: subscription });
  },

  async unsubscribe(endpoint: string): Promise<void> {
    await apiRequest("/v1/partner/push/subscriptions", { method: "DELETE", body: { endpoint } });
  },
};
